module.exports = __webpack_public_path__ + "static/media/frog(20).2618ec76.PNG";